import { render } from "./RankingReportTable.vue?vue&type=template&id=a6295b84&scoped=true"
import script from "./RankingReportTable.vue?vue&type=script&lang=js"
export * from "./RankingReportTable.vue?vue&type=script&lang=js"

import "./RankingReportTable.vue?vue&type=style&index=0&id=a6295b84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6295b84"]])

export default __exports__